import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomerAgent } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CustomerAgentService extends TmsWebBaseEditCreateService<CustomerAgent, CustomerAgent> {
  constructor() {
    super('CustomerAgent', $localize`Customer Agent`);
  }

  getForCustomer(customerId: string): Observable<CustomerAgent[]> {
    return this.httpService.get<CustomerAgent[]>(`${this.apiUrl}/Customer/${customerId}`);
  }
}
